/**
 * Get translation string
 * @param {string} key - Translation key
 * @param {Object} params - Parameters to replace in translation
 * @returns {string} - Translated string
 */
const t = (key, params = {}) => {
  const translations = window.sharedCartTranslations || {};
  let translation = translations[key] || key;
  
  // Replace parameters in translation (e.g., {{ param }})
  // Handle both {{ param }} and {{param}} formats
  Object.keys(params).forEach(param => {
    const value = params[param];
    // Replace {{ param }} format
    translation = translation.replace(new RegExp(`{{\\s*${param}\\s*}}`, 'g'), value);
  });
  
  return translation;
};

/**
 * Show shared cart notification banner
 * @param {string} fullMessage - Full message text
 * @param {Array} messages - Array of message parts (unused, kept for compatibility)
 */
const showSharedCartNotification = (fullMessage, messages) => {
  const banner = document.getElementById('shared-cart-notification-banner');
  const messageElement = document.getElementById('shared-cart-notification-message');
  const closeButton = document.getElementById('shared-cart-notification-close');
  
  // If banner doesn't exist (disabled for this market), silently return
  if (!banner || !messageElement) {
    return;
  }
  
  // Format message: make first part (before dash) bold
  const dashIndex = fullMessage.indexOf(' - ');
  if (dashIndex > 0) {
    const boldPart = fullMessage.substring(0, dashIndex);
    const normalPart = fullMessage.substring(dashIndex);
    messageElement.innerHTML = `<strong>${boldPart}</strong>${normalPart}`;
  } else {
    messageElement.innerHTML = fullMessage;
  }
  
  // Show banner
  banner.style.display = 'block';
  document.body.classList.add('shared-cart-banner-visible');
  
  // Scroll to top to show banner
  window.scrollTo({ top: 0, behavior: 'smooth' });
  
  // Close button handler
  if (closeButton) {
    const closeHandler = () => {
      banner.style.display = 'none';
      document.body.classList.remove('shared-cart-banner-visible');
      closeButton.removeEventListener('click', closeHandler);
    };
    closeButton.addEventListener('click', closeHandler);
  }
  
  // Auto-hide after 10 seconds (optional)
  setTimeout(() => {
    if (banner.style.display !== 'none') {
      banner.style.display = 'none';
      document.body.classList.remove('shared-cart-banner-visible');
    }
  }, 20000);
};

const loader2 = document.getElementById('page-loader');
document.addEventListener('DOMContentLoaded', async (event) => {
  const invalidurlsharecart = document.querySelector('.invalid_url_sharecart');
    try {
      loader2.classList.remove("hidden");
        // Check if cart needs reloading based on cartToken and sessionStorage
        const cartToken = checkCartTokenInUrl();
        const storedCartToken = sessionStorage.getItem('storedCartToken');
  
        if (cartToken && cartToken !== storedCartToken) {
          sessionStorage.setItem('storedCartToken', cartToken);
              await fetch('/cart/clear.js', {
                method: 'POST',
              }).then(response => response.json())
                .then(data => {
                  // Cart cleared
                })
                .catch((error) => {
                  // Error clearing cart
                });
          const cartContent = await retrieveCart();

          // Set partner from shared cart data into cookie/localStorage so the receiver
          // gets a partnerID cookie for Cloudflare and updateCartFormAction().
          const sharedPartnerId = cartContent?.attributes?._partner_id;
          if (sharedPartnerId) {
            setCookie('partnerID', sharedPartnerId, 180);
            localStorage.setItem('partnerInfo', JSON.stringify({ commSysPartnerID: sharedPartnerId }));
          }

          await refreshCart();

          if (typeof window.refreshCartPaymentMethods === "function") {            
            // Create a promise that resolves after refreshCartPaymentMethods completes
            await new Promise((resolve) => {
              setTimeout(async () => {
                await window.refreshCartPaymentMethods();
                resolve();
              }, 100);
            });
          }
          if (typeof window.syncPartnerInfoToCartAttributes === 'function') {
            const urlParams = new URLSearchParams(window.location.search);
            const partnerIdFromUrl = urlParams.get('partner') || urlParams.get('commSysPartnerID');

            const partnerIdFromCart = cartContent?.attributes?._partner_id;
            if (partnerIdFromUrl && partnerIdFromUrl !== partnerIdFromCart) {
              await window.syncPartnerInfoToCartAttributes(partnerIdFromUrl).catch(() => {});
            }
          }
        }
    } catch (error) {
      if (invalidurlsharecart) {
        invalidurlsharecart.style.display = 'block';
      }
    } finally {
      // Hide loader after processing
      loader2.classList.add('hidden');
      $('#AjaxCartSubtotal').css('display', 'block');
      
      // Dispatch custom event to signal completion
    document.dispatchEvent(new Event('customCartLoaded'));
    }
});

const checkCartTokenInUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('cart_token');
};

const retrieveCart = async () => {
  const cartToken = checkCartTokenInUrl();  
  const apiUrl = KROWN.settings.shared_cart.get_cart_by_token + cartToken;
    try {
      const response = await fetch(apiUrl, { method: 'POST' });
      const data = await response.json();
      await addProductsToCart(data);
      return data;
      } catch (error) {
      // Error fetching cart data
  }
};

/**
 * Get current store region from URL
 */
const getCurrentStoreRegion = () => {
  const currentUrl = window.location.href;
  try {
    const url = new URL(currentUrl);
    const hostname = url.hostname;
    // Extract region from hostname (e.g., us.mkt.juiceplus.com -> us)
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const region = parts[0];
      return region; // First part is usually the region code
    }
    return null;
  } catch (e) {
    return null;
  }
};

/**
 * Extract region from shared cart URL
 */
const getSharedCartRegion = (sharedCartUrl) => {
  if (!sharedCartUrl) {
    return null;
  }
  try {
    const url = new URL(sharedCartUrl);
    const hostname = url.hostname;
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const region = parts[0];
      return region;
    }
    return null;
  } catch (e) {
    return null;
  }
};

/**
 * Get current locale from URL path (prioritize URL over window.currentLocale)
 * @returns {string} - Current locale code from URL (e.g., 'en', 'de', 'es') or empty string
 */
const getCurrentLocale = () => {
  // Prioritize URL path over window.currentLocale to match actual URL structure
  // Extract locale from URL (e.g., /en/products/... or /de/products/...)
  const pathMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[A-Z]{2})?)\//);
  if (pathMatch) {
    return pathMatch[1];
  }
  
  // Fallback to window.currentLocale if no locale in URL path
  if (window.currentLocale) {
    return window.currentLocale;
  }
  
  // Return empty string if no locale found (will use /products/ without locale)
  return '';
};

/**
 * Fetch translated product title
 * @param {string} productHandle - The product handle
 * @param {number} variantId - The variant ID
 * @returns {Promise<string|null>} - Translated product title or null
 */
const fetchTranslatedProductTitle = async (productHandle, variantId) => {
  try {
    // Product URLs don't include locale code - always use /products/ path
    // Note: Draft products will return 404, so we'll fall back to original title
    const productUrl = `/products/${productHandle}.js`;
    
    // Suppress console errors for expected 404s (draft products)
    // Use catch to prevent unhandled promise rejections
    const response = await fetch(productUrl).catch(() => null);
    
    if (!response) {
      return null;
    }
    
    if (response.ok) {
      const productData = await response.json();
      const variant = productData.variants.find(v => v.id === variantId);
      if (variant && productData.title) {
        // Return the product title (Shopify automatically translates it based on locale in URL)
        return productData.title;
      }
    } else if (response.status === 404) {
      // Product not found (likely draft or unpublished) - will use fallback title
      // This is expected, so we don't log it as an error
      return null;
    }
  } catch (error) {
    return null;
    // Silently fail - will use fallback title from shared cart data
    // This handles cases like draft products, network errors, etc.
    // Don't log expected errors (404 for drafts, network timeouts, etc.)
  }
  return null;
};

/**
 * Fetch variant data from Shopify to check availability and price
 * @param {number} variantId - The variant ID
 * @param {string} productHandle - The product handle
 * @param {number|null} sellingPlanId - The selling plan ID (if subscription)
 */
const fetchVariantData = async (variantId, productHandle, sellingPlanId = null) => {
  try {
    // Try to fetch variant data via product handle
    if (productHandle) {
      // Product URLs don't include locale code - always use /products/ path
      const productUrl = `/products/${productHandle}.js`;
      const response = await fetch(productUrl).catch(() => null);
      if (response && response.ok) {
        const productData = await response.json();
        const variant = productData.variants.find(v => v.id === variantId);
        if (variant) {
          let price = variant.price;
          let compare_at_price = variant.compare_at_price;
          
          // If selling plan is present, get the selling plan price
          if (sellingPlanId && variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const sellingPlanAllocation = variant.selling_plan_allocations.find(
              spa => spa.selling_plan && spa.selling_plan.id === sellingPlanId
            );
            
            if (sellingPlanAllocation) {
              price = sellingPlanAllocation.price;
              compare_at_price = sellingPlanAllocation.compare_at_price;
            } else {
              // If exact selling plan not found, use first available selling plan price
              const firstSellingPlan = variant.selling_plan_allocations[0];
              if (firstSellingPlan) {
                price = firstSellingPlan.price;
                compare_at_price = firstSellingPlan.compare_at_price;
              }
            }
          }
          
          return {
            available: variant.available,
            price: price,
            compare_at_price: compare_at_price,
            inventory_quantity: variant.inventory_quantity,
            inventory_policy: variant.inventory_policy
          };
        }
      }
    }
    
    // Fallback: try to get from cart.js to see current prices
    const cartResponse = await fetch('/cart.js').catch(() => null);
    if (cartResponse && cartResponse.ok) {
      const cartData = await cartResponse.json();
      const existingItem = cartData.items.find(item => 
        item.variant_id === variantId && 
        (!sellingPlanId || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id === sellingPlanId))
      );
      if (existingItem) {
        // Use selling plan price if available, otherwise use regular price
        const itemPrice = existingItem.selling_plan_allocation && existingItem.selling_plan_allocation.price 
          ? existingItem.selling_plan_allocation.price 
          : existingItem.price;
        
        return {
          available: true,
          price: itemPrice,
          compare_at_price: existingItem.compare_at_price
        };
      }
    }
    
    return null;
  } catch (error) {
    return null;
  }
};

/**
 * Validate and prepare items for cart addition
 */
const validateCartItems = async (sharedCartData) => {
  const currentRegion = getCurrentStoreRegion();
  const sharedRegion = getSharedCartRegion(sharedCartData.current_url);
  const isSameRegion = currentRegion && sharedRegion && currentRegion.toLowerCase() === sharedRegion.toLowerCase();
  
  const validatedItems = [];
  const warnings = [];
  const errors = [];
  
  for (let i = 0; i < sharedCartData.items.length; i++) {
    const item = sharedCartData.items[i];
    const variantId = item.variant_id;
    const productHandle = item.handle;
    
    // Get selling plan ID if present
    const sellingPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan 
      ? item.selling_plan_allocation.selling_plan.id 
      : null;
    
    // Use selling plan price if available, otherwise use regular price
    const sharedPrice = item.selling_plan_allocation && item.selling_plan_allocation.price
      ? item.selling_plan_allocation.price
      : (item.price || item.final_price || item.line_price);
    
    // Fetch current variant data (with selling plan if present)
    const currentVariantData = await fetchVariantData(variantId, productHandle, sellingPlanId);
    
    // Try to get translated product title
    let translatedTitle = null;
    if (productHandle) {
      translatedTitle = await fetchTranslatedProductTitle(productHandle, variantId);
    }
    const productTitle = translatedTitle || item.title || item.product_title;
    
    if (!currentVariantData) {
      // Variant not found or couldn't fetch data - still try to add it
      validatedItems.push({
        id: variantId,
        quantity: item.quantity,
        selling_plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan 
          ? item.selling_plan_allocation.selling_plan.id 
          : null,
        properties: item.properties
      });
      continue;
    }
    
    // Check availability
    if (!currentVariantData.available && currentVariantData.inventory_quantity === 0) {
      errors.push({
        variantId,
        title: productTitle
      });
      continue; // Skip unavailable items
    }
    
    // Compare prices if same region - track if price changed
    if (isSameRegion && sharedPrice && currentVariantData.price) {
      const priceDifference = Math.abs(sharedPrice - currentVariantData.price);
      const priceDifferencePercent = (priceDifference / sharedPrice) * 100;
      
      // If price difference is more than 1% (to account for rounding), track as warning
      if (priceDifferencePercent > 1) {
        warnings.push({
          variantId,
          title: productTitle
        });
      }
    }
    
    // Add validated item
    validatedItems.push({
      id: variantId,
      quantity: item.quantity,
      selling_plan: item.selling_plan_allocation && item.selling_plan_allocation.selling_plan 
        ? item.selling_plan_allocation.selling_plan.id 
        : null,
      properties: item.properties
    });
  }
  
  return {
    items: validatedItems,
    warnings,
    errors,
    isSameRegion
  };
};

const addProductsToCart = async (sharedCartData) => {
  try {
    // Validate items before adding
    const validation = await validateCartItems(sharedCartData);
    
    
    // If no valid items, return early
    if (validation.items.length === 0) {
      showSharedCartNotification(
        t('cartUpdated'),
        [t('cartUpdated')]
      );
      return;
    }
    
    const cartAttributes = sharedCartData.attributes;
    
    // Store payment method type
    sessionStorage.setItem("paymentMethodType", cartAttributes._paymentMethod);
    
    // Helper function to add a single item to cart
    const addSingleItemToCart = async (item, attributes) => {
      try {
        // Get cart state before adding to compare later
        const cartBeforeResponse = await fetch('/cart.js').catch(() => null);
        if (!cartBeforeResponse) {
          return {
            success: false,
            error: t('cartUpdated'),
            item: item
          };
        }
        const cartBefore = await cartBeforeResponse.json();
        const quantityBefore = cartBefore.items.find(cartItem => cartItem.variant_id === item.id)?.quantity || 0;
        
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            attributes: attributes,
            items: [item]
          })
        }).catch(() => null);
      
      if (!response) {
        return {
          success: false,
          error: t('cartUpdated'),
          item: item
        };
      }
        
      if (!response.ok) {
        // 422 is expected for partial inventory - we handle it gracefully
        // Check cart state after error to see if partial quantity was added
        const cartAfterResponse = await fetch('/cart.js').catch(() => null);
        if (!cartAfterResponse) {
          return {
            success: false,
            error: t('cartUpdated'),
            item: item
          };
        }
        
        const cartAfter = await cartAfterResponse.json();
        const quantityAfter = cartAfter.items.find(cartItem => cartItem.variant_id === item.id)?.quantity || 0;
        const quantityAdded = quantityAfter - quantityBefore;
        
        if (quantityAdded > 0 && quantityAdded < item.quantity) {
          // Partial quantity was added (422 is expected for this scenario)
          const errorData = await response.json().catch(() => ({}));
          return {
            success: true, // Mark as success but with partial quantity
            partial: true,
            data: cartAfter,
            item: { ...item, quantity: quantityAdded },
            requestedQuantity: item.quantity,
            addedQuantity: quantityAdded,
            missingQuantity: item.quantity - quantityAdded,
            error: errorData.description || errorData.message || t('cartUpdated')
          };
        } else {
          // No quantity was added
          const errorData = await response.json().catch(() => ({}));
          return {
            success: false,
            error: errorData.description || errorData.message || t('cartUpdated'),
            item: item
          };
        }
      }
        
      const data = await response.json();
        return {
          success: true,
          data: data,
          item: item
        };
    } catch (error) {
        return {
          success: false,
          error: error.message || t('cartUpdated'),
          item: item
        };
      }
    };
    
    // Add items individually for better error handling and clarity
    const itemsAddedSuccessfully = [];
    const itemsFailed = [];
    
    
    for (let i = 0; i < validation.items.length; i++) {
      const item = validation.items[i];
      const sharedItem = sharedCartData.items.find(shared => shared.variant_id === item.id);
      
      // Try to get translated product title
      let itemTitle = `Variant ${item.id}`; // Fallback
      if (sharedItem) {
        const productHandle = sharedItem.handle;
        if (productHandle) {
          const translatedTitle = await fetchTranslatedProductTitle(productHandle, item.id);
          itemTitle = translatedTitle || sharedItem.title || sharedItem.product_title || itemTitle;
        } else {
          itemTitle = sharedItem.title || sharedItem.product_title || itemTitle;
        }
      }
      
      // Set attributes only on the first item
      const itemAttributes = i === 0 ? cartAttributes : {};
      
     
      
      const result = await addSingleItemToCart(item, itemAttributes);
      
     
      
      if (result.success) {
        if (result.partial) {
          // Partial quantity added - track it separately
          
          itemsAddedSuccessfully.push({
            item: result.item, // Use the actual quantity added
            title: itemTitle,
            data: result.data,
            partial: true,
            requestedQuantity: result.requestedQuantity,
            addedQuantity: result.addedQuantity,
            missingQuantity: result.missingQuantity
          });
        } else {
          // Full quantity added
          itemsAddedSuccessfully.push({
            item: item,
            title: itemTitle,
            data: result.data
          });
        }
      } else {
        itemsFailed.push({
          item: item,
          title: itemTitle,
          error: result.error,
          reason: result.error || t('cartUpdated')
        });
      }
      
      // Small delay between requests to avoid rate limiting
      if (i < validation.items.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
    
    
    
    // If no items were added successfully, show notification and return
    if (itemsAddedSuccessfully.length === 0) {
      showSharedCartNotification(
        t('cartUpdated'),
        [t('cartUpdated')]
      );
      return;
    }
    
    // Get the final cart state
    const cartResponse = await fetch('/cart.js');
    const data = await cartResponse.json();
    
    
    
    // Compare requested items with actually added items in cart
    const itemsNotAdded = [];
    const itemsPartiallyAdded = [];
    
    
    // Add failed items to itemsNotAdded
    itemsFailed.forEach(failed => {
      itemsNotAdded.push({
        variantId: failed.item.id,
        title: failed.title,
        quantity: failed.item.quantity,
        reason: failed.reason || failed.error || t('cartUpdated')
      });
    });
    
    // Check for partial quantity adds from successful adds that were marked as partial
    itemsAddedSuccessfully.forEach(successItem => {
      if (successItem.partial) {
        itemsPartiallyAdded.push({
          variantId: successItem.item.id,
          title: successItem.title,
          requestedQuantity: successItem.requestedQuantity,
          addedQuantity: successItem.addedQuantity,
          missingQuantity: successItem.missingQuantity,
          reason: t('cartUpdated')
        });
      }
    });
    
    
    
    // Also check cart state for any discrepancies (double-check)
    for (const requestedItem of validation.items) {
      // Skip if this item already failed or was marked as partial
      if (itemsFailed.some(f => f.item.id === requestedItem.id)) {
        continue;
      }
      if (itemsPartiallyAdded.some(p => p.variantId === requestedItem.id)) {
        continue;
      }
      
      // Find the item title from shared cart data - try to get translated title
      const sharedItem = sharedCartData.items.find(item => item.variant_id === requestedItem.id);
      let itemTitle = `Variant ${requestedItem.id}`; // Fallback
      if (sharedItem) {
        const productHandle = sharedItem.handle;
        if (productHandle) {
          // Fetch translated title
          const translatedTitle = await fetchTranslatedProductTitle(productHandle, requestedItem.id);
          itemTitle = translatedTitle || sharedItem.title || sharedItem.product_title || itemTitle;
        } else {
          itemTitle = sharedItem.title || sharedItem.product_title || itemTitle;
        }
      }
      
      // Check if this item exists in the cart response
      const addedItem = data.items && data.items.find(addedItem => 
        addedItem.variant_id === requestedItem.id
      );
      
      if (!addedItem) {
        // Item was not added at all (shouldn't happen if individual add succeeded, but check anyway)
        itemsNotAdded.push({
          variantId: requestedItem.id,
          title: itemTitle,
          quantity: requestedItem.quantity,
          reason: t('cartUpdated')
        });
      } else if (addedItem.quantity < requestedItem.quantity) {
        // Partial quantity added (catch any we might have missed)
        const alreadyTracked = itemsPartiallyAdded.some(p => p.variantId === requestedItem.id);
        if (!alreadyTracked) {
          itemsPartiallyAdded.push({
            variantId: requestedItem.id,
            title: itemTitle,
            requestedQuantity: requestedItem.quantity,
            addedQuantity: addedItem.quantity,
            missingQuantity: requestedItem.quantity - addedItem.quantity,
            reason: t('cartUpdated')
          });
        }
      }
    }
    
    // Check if any changes occurred (errors, items not added, partial adds, or price changes)
    const hasChanges = validation.errors.length > 0 || 
                       itemsNotAdded.length > 0 || 
                       itemsPartiallyAdded.length > 0 || 
                       validation.warnings.length > 0;
    
    // Show single notification message if any changes occurred
    if (hasChanges) {
      showSharedCartNotification(
        t('cartUpdated'),
        [t('cartUpdated')]
      );
    } 

    
  } catch (error) {
    throw error;
  }
};

